import LocalDateTime from '~/lib/localdatetime';

type ScheduleEntryConflict = {
    appointmentTitle: string;
    customerName: string;
    practitionerId: number;
    stepStartSerialized: string;
    blockerStartSerialized: string;
    blockerEndSerialized: string;
};

// The server input caps the list, so keep the client in sync.
const MAX_LOGGED_CONFLICTS = 50;

/**
 * Turns the appointment conflicts shown before saving a blocker into per-practitioner
 * log messages, so overridden conflicts stay visible in the logs.
 */
export function serializeConflictsForLog(
    conflicts: { conflicts: ScheduleEntryConflict[] } | null | undefined
): { practitionerId: number; message: string }[] | undefined {
    if (!conflicts || conflicts.conflicts.length === 0) return undefined;

    const formatTime = (serialized: string) => LocalDateTime.deserialize(serialized).format('dd.MM.yyyy HH:mm');

    return conflicts.conflicts.slice(0, MAX_LOGGED_CONFLICTS).map((conflict) => ({
        practitionerId: conflict.practitionerId,
        message: `Termin "${conflict.appointmentTitle}" (${conflict.customerName}) am ${formatTime(conflict.stepStartSerialized)} überschneidet sich mit Blockierung (${formatTime(conflict.blockerStartSerialized)} - ${formatTime(conflict.blockerEndSerialized)})`,
    }));
}
